import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, filter, takeUntil } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { shipStationStore } from 'src/app/models/settings.model';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-shipstation-connection-details',
  templateUrl: './shipstation-connection-details.component.html',
  styleUrls: ['./shipstation-connection-details.component.scss']
})
export class ShipstationConnectionDetailsComponent implements OnInit,OnDestroy {
  loader:boolean=false;
  private destroy$ = new Subject();
  shipStationStore:shipStationStore[]=[];
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ShipstationConnectionDetailsComponent>,
    private settingsService: SettingsService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.GetShipStationStores();
  }


  action(e?: any) {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  GetShipStationStores() {
    this.loader=true;
    this.settingsService.GetShipStationStores().pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: shipStationStore[]) => {
        this.loader=false;
         this.shipStationStore = data;
      },
      error: (error) => {
        this.loader=false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    });
  }

  saveShipmentStore(shipStation) {
    const payload = {
      accountNames: [shipStation.accountName]
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Save ShipStation Stores",
          message: "Are you sure you want to Save this ShipStation Stores?",
        },
      })
      .afterClosed().subscribe((e) => {
        if (e === 'Confirm') {
          this.settingsService.SaveShipStationStores(payload).pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
              let idx = this.shipStationStore.findIndex((el) => el.accountName == shipStation.accountName);
              if (idx !== -1) {
                this.shipStationStore[idx].isSync = true;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'Save ShipStation Stores successfully',
                    action: 'Dismiss',
                    type: 'success',
                  },
                }
              );
            },
            error: (err) => {
              shipStation.isSync = false;
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: err.error.error[0],
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
              );
            }
          })
        }
        else {
          shipStation.isSync  = false;
        }
      });
  }

  deleteShipStationStores(shipStation) {
    const payload = {
      accountNames: [shipStation.accountName]
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Delete ShipStation Stores",
          message: "Are you sure you want to delete this ShipStation Stores?",
        },
      })
      .afterClosed()
      .subscribe((e) => {
      if (e === 'Confirm') {
        this.settingsService.DeleteShipStationStores(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (data) => {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'ShipStation Store deleted successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
          },
          error: (err) => {
            shipStation.isSync = true;
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err.error.error[0],
                  action: 'Dismiss',
                  type: 'error',
                },
              }
            );
          }
        });
        }else{
          shipStation.isSync  = true;
        }
      });
  }

  onCheckboxChange(shipStation) {
    if (shipStation.isSync) {
      this.saveShipmentStore(shipStation);
    } else this.deleteShipStationStores(shipStation);
  }
}
